import { bulkPutCollector, bulkPostCollector, putCollector } from 'src/apiHelper/collectorApi'
import moment from 'moment'
import { setBulkVisitRecall } from 'src/helper/backendHelper'
import { dateDbFormat } from '../../../utils/dateTimeUtils'
import { VISIT_STATUS } from '../../../utils/statusConstants'
import { COLLECTOR_URL } from '../../../apiHelper/apiRoute/collector'
import { createNewPatientEvent } from '../../../helper/fusionHelper'
import FeaturesConstants from '../../../utils/featuresConstants'

export const stopVisitTracking = async (visits, selectedDate, features) => {
  let sucessVisitsCount = 0
  let failedVisitsCount = 0
  // 3 array of objects
  let lastDischarge = []
  let scheduledDischarge = []
  let otherDischarge = []

  let allSuccessItems = []

  for (let i = 0; i < visits.length; i++) {
    const visit = visits[i]
    const visitId = visit.visitId || visit._id
    if (visit.status === VISIT_STATUS.last) {
      const body = {
        visit_id: visitId,
        status: VISIT_STATUS.not_seen,
        service_date: selectedDate,
        last_visit: true,
      }
      lastDischarge.push(body)
    } else if (
      visit.status === VISIT_STATUS.scheduled ||
      visit.status === VISIT_STATUS.checked_in ||
      visit.status === VISIT_STATUS.admit
    ) {
      const body = {
        visit_id: visitId,
        status: VISIT_STATUS.not_seen,
        last_visit: true,
      }
      scheduledDischarge.push(body)
    } else {
      const body = {
        visit_id: visitId,
        key: 'last_visit',
        value: true,
      }
      otherDischarge.push(body)
    }
  }

  if (lastDischarge.length > 0) {
    const url = COLLECTOR_URL.BULK_CLONE
    let result = await bulkPostCollector(url, JSON.stringify(lastDischarge))
    if (result?.status === 'sucesss') {
      result.data.forEach((item) => {
        if (item.status === 'success') {
          sucessVisitsCount++
          allSuccessItems.push({
            charge_id: item?.result?._id,
            patient_id: item?.result?.patient_id,
            date: moment.utc(item?.result?.service_date_from).toISOString(),
            service_date_from: item?.result?.service_date_from,
          })
        }
        if (item.status === 'failure') {
          failedVisitsCount++
        }
      })
    }
  }

  if (scheduledDischarge.length > 0) {
    const url = COLLECTOR_URL.BULK_VISIT_STATUS
    let result = await bulkPutCollector(
      url,
      JSON.stringify({
        visit_id: scheduledDischarge.map((x) => x.visit_id),
        status: scheduledDischarge.map((x) => x.status),
        last_visit: scheduledDischarge.map((x) => x.last_visit),
      }),
    )

    if (result?.status === 'sucesss') {
      result.data.forEach((item) => {
        if (item.status === 'success') {
          sucessVisitsCount++
          allSuccessItems.push({
            charge_id: item?.result?._id,
            patient_id: item?.result?.patient_id,
            date: moment.utc(item?.result?.service_date_from).toISOString(),
            service_date_from: item?.result?.service_date_from,
          })
        }
        if (item.status === 'failure') {
          failedVisitsCount++
        }
      })
    }
  }

  if (otherDischarge.length > 0) {
    const url = COLLECTOR_URL.BULK_VISIT_STATUS_KEY
    let result = await bulkPutCollector(url, {
      visit_id: otherDischarge.map((x) => x.visit_id),
      key: otherDischarge.map((x) => x.key),
      value: otherDischarge.map((x) => x.value),
    })

    if (result?.status === 'sucesss') {
      result.data.forEach((item) => {
        if (item.status === 'success') {
          sucessVisitsCount++
          let originalVisit = visits?.find((v) => v._id === item?._id)
          if (originalVisit) {
            allSuccessItems.push({
              charge_id: originalVisit?._id,
              patient_id: originalVisit?.patient_id,
              date: moment.utc(originalVisit?.service_date_from).toISOString(),
              service_date_from: originalVisit?.service_date_from,
            })
          }
        }
        if (item.status === 'failure') {
          failedVisitsCount++
        }
      })
    }
  }

  if (features.includes(FeaturesConstants.InsuranceMapper)) {
    allSuccessItems.forEach((item) => {
      // add discharge event to all success discharges
      createNewPatientEvent({
        ...item,
        service_date_from: item?.service_date_from,
        type: 'DISCHARGE',
        source: 'COL-API',
      })
    })
  }
  return { sucessVisitsCount, failedVisitsCount, allSuccessVisits: allSuccessItems }
}

export const myCensus = async (visits, selectedDate) => {
  let sucessVisitsCount = 0
  let failedVisitsCount = 0
  let failedToastDescription = ''

  let visitSuccesses = []

  let lastMYCensus = []
  let admitMyCensus = []
  for (let i = 0; i < visits.length; i++) {
    const visit = visits[i]
    const visitId = visit.visitId || visit._id

    if (visit.status === VISIT_STATUS.last) {
      let body = {
        visit_id: visitId,
        status: VISIT_STATUS.checked_in,
        service_date: dateDbFormat(selectedDate),
      }
      lastMYCensus.push(body)
    } else if (
      visit.status === VISIT_STATUS.scheduled ||
      visit.status === VISIT_STATUS.not_seen ||
      visit.status === VISIT_STATUS.admit
    ) {
      let body = {
        visit_id: visitId,
        status: VISIT_STATUS.checked_in,
      }
      admitMyCensus.push(body)
    }
  }
  if (lastMYCensus.length > 0) {
    const url = COLLECTOR_URL.BULK_CLONE
    let result = await bulkPostCollector(url, JSON.stringify(lastMYCensus))
    if (result?.status === 'sucesss') {
      result.data.forEach((item) => {
        if (item.status === 'success') {
          sucessVisitsCount++
          visitSuccesses.push(item)
        }
        if (item.status === 'failure') failedVisitsCount++
      })
    }
  }
  if (admitMyCensus.length > 0) {
    const url = COLLECTOR_URL.BULK_VISIT_STATUS
    let result = await bulkPutCollector(url, {
      visit_id: admitMyCensus.map((x) => x.visit_id),
      status: admitMyCensus.map((x) => x.status),
    })

    if (result?.status === 'sucesss') {
      result.data.forEach((item) => {
        if (item.status === 'success') {
          sucessVisitsCount++
          visitSuccesses.push(item)
        }
        if (item.status === 'failure') failedVisitsCount++
      })
      failedToastDescription = result.data[0].err
    }
  }
  return { sucessVisitsCount, failedVisitsCount, failedToastDescription, visitSuccesses }
}
export const addlVisit = async (visits, selectedDate) => {
  let sucessVisitsCount = 0
  let failedVisitsCount = 0
  let successId = []
  let failedToastDescription = ''

  let lastMYCensus = []
  for (let i = 0; i < visits.length; i++) {
    const visit = visits[i]
    const visitId = visit.visitId || visit._id
    let body = {
      visit_id: visitId,
      status: VISIT_STATUS.checked_in,
      service_date: dateDbFormat(selectedDate),
    }
    lastMYCensus.push(body)
  }
  if (lastMYCensus.length > 0) {
    const url = COLLECTOR_URL.BULK_CLONE
    let result = await bulkPostCollector(url, JSON.stringify(lastMYCensus))
    if (result?.status === 'sucesss') {
      result.data.forEach((item) => {
        if (item.status === 'success') {
          successId.push(item?.result)
          sucessVisitsCount++
        }
        if (item.status === 'failure') failedVisitsCount++
      })
    }
  }

  return { sucessVisitsCount, failedVisitsCount, failedToastDescription, successId }
}

export const billSaltUtil = async (visits, selectedDate) => {
  let sucessVisitsCount = 0
  let failedVisitsCount = 0

  let lastBillSaltObj = []
  let lastBillSubmitObj = []
  for (let i = 0; i < visits.length; i++) {
    const visit = visits[i]
    const visitId = visit.visitId || visit._id
    if (visit.status === VISIT_STATUS.last) {
      // Disable SALT for initial diagnosis visit E&M codes -- this should be ultimately DB config driven
      let exclude = ['99218', '99219', '99220', '99221', '99222', '99223'] //for testing purpose

      if (exclude.indexOf(visit.procedure_code_primary.code) > -1) {
        // await visitProcedureMenu(visit, null, undefined, '')
      } else {
        const billSaltBody = {
          visit_id: visitId,
          status: VISIT_STATUS.checked_in,
          service_date: selectedDate,
        }
        lastBillSaltObj.push(billSaltBody)
      }
    }
  }

  if (lastBillSaltObj.length > 0) {
    const url = COLLECTOR_URL.BULK_CLONE
    //This is visit clone API
    let result = await bulkPostCollector(url, lastBillSaltObj)
    if (result?.status === 'sucesss') {
      result.data.forEach((item) => {
        if (item.status === 'success') {
          lastBillSubmitObj.push(item?.result?._id)
        }
        if (item.status === 'failure') failedVisitsCount++
      })

      if (lastBillSubmitObj.length > 0) {
        const url = COLLECTOR_URL.BULK_BILL_SUBMIT
        //This is bill submit API
        let result = await bulkPostCollector(url, {
          visit_id: lastBillSubmitObj,
        })
        if (result?.status === 'sucesss') {
          result.data.forEach((item) => {
            if (item.status === 'success') sucessVisitsCount++
            if (item.status === 'failure') failedVisitsCount++
          })
          return { sucessVisitsCount, failedVisitsCount }
        } else {
          return { sucessVisitsCount, failedVisitsCount }
        }
      }
    }
  } else {
    return { sucessVisitsCount: 0, failedVisitsCount: visits.length }
  }
}

export const undoLastVisit = async (visits) => {
  let sucessVisitsCount = 0
  let failedVisitsCount = 0

  let undoDischargeVisits = []
  for (let i = 0; i < visits.length; i++) {
    const visit = visits[i]
    const visitId = visit.visitId || visit._id
    let body = {
      visit_id: visitId,
      key: 'last_visit',
      value: false,
    }
    undoDischargeVisits.push(body)
  }
  if (undoDischargeVisits.length > 0) {
    const url = COLLECTOR_URL.BULK_VISIT_STATUS_KEY

    let result = await bulkPutCollector(url, {
      visit_id: undoDischargeVisits.map((x) => x.visit_id),
      key: undoDischargeVisits.map((x) => x.key),
      value: undoDischargeVisits.map((x) => x.value),
    })
    if (result?.status === 'sucesss') {
      result.data.forEach((item) => {
        if (item.status === 'success') sucessVisitsCount++
        if (item.status === 'failure') failedVisitsCount++
      })
    }
  }

  return { sucessVisitsCount, failedVisitsCount }
}

export const recallBill = async (visits, messageText = '') => {
  let result_visits = []

  let sucessVisitsCount = 0
  let failedVisitsCount = 0
  const recalBody = []

  for (let i = 0; i < visits.length; i++) {
    const visit = visits[i]
    const visitId = visit.visitId || visit._id

    recalBody.push(visitId)
  }

  let payload = {
    visit_id: recalBody,
    messageText: messageText,
  }
  if (recalBody.length > 0) {
    const result = await setBulkVisitRecall(payload)

    if (result?.status === 'sucesss') {
      result.data.forEach((item) => {
        if (item.status === 'success') {
          result_visits.push(item)
          sucessVisitsCount++
        }
        if (item.status === 'failure') failedVisitsCount++
      })
    }
  }
  return { sucessVisitsCount, failedVisitsCount, result_visits }
}

export const skipVisit = async (visits, selectedDate) => {
  let sucessVisitsCount = 0
  let failedVisitsCount = 0

  let lastSkipVisits = []
  let otherSkipVisits = []

  let successfulVisits = []

  for (let i = 0; i < visits.length; i++) {
    const visit = visits[i]
    const visitId = visit.visitId || visit._id
    if (visit.status === VISIT_STATUS.last) {
      let body = {
        visit_id: visitId,
        status: VISIT_STATUS.not_seen,
        service_date: moment(selectedDate).format('YYYY-MM-DD'),
      }
      lastSkipVisits.push(body)
    } else {
      let body = {
        visit_id: visitId,
        status: VISIT_STATUS.not_seen,
      }
      otherSkipVisits.push(body)
    }
  }

  if (lastSkipVisits.length > 0) {
    const url = COLLECTOR_URL.BULK_CLONE
    let result = await bulkPostCollector(url, JSON.stringify(lastSkipVisits))
    if (result?.status === 'sucesss') {
      result.data.forEach((item) => {
        if (item.status === 'success') {
          sucessVisitsCount++
          successfulVisits.push(item)
        }
        if (item.status === 'failure') failedVisitsCount++
      })
    }
  }

  if (otherSkipVisits.length > 0) {
    const url = COLLECTOR_URL.BULK_VISIT_STATUS
    let result = await bulkPutCollector(url, {
      visit_id: otherSkipVisits.map((x) => x.visit_id),
      status: otherSkipVisits.map((x) => x.status),
    })

    if (result?.status === 'sucesss') {
      result.data.forEach((item) => {
        if (item.status === 'success') {
          sucessVisitsCount++
          successfulVisits.push(item)
        }
        if (item.status === 'failure') failedVisitsCount++
      })
    }
  }

  return { sucessVisitsCount, failedVisitsCount, successfulVisits }
}

export const undoSkipVisit = async (visits) => {
  let sucessVisitsCount = 0
  let failedVisitsCount = 0

  let undoSkipVisits = []
  for (let i = 0; i < visits.length; i++) {
    const visit = visits[i]
    const visitId = visit.visitId || visit._id
    if (visit.status === VISIT_STATUS.not_seen) {
      let body = {
        visit_id: visitId,
        status: VISIT_STATUS.scheduled,
      }
      undoSkipVisits.push(body)
    }
  }

  if (undoSkipVisits.length > 0) {
    const url = COLLECTOR_URL.BULK_VISIT_STATUS
    let result = await bulkPutCollector(url, {
      visit_id: undoSkipVisits.map((x) => x.visit_id),
      status: undoSkipVisits.map((x) => x.status),
    })
    if (result?.status === 'sucesss') {
      result.data.forEach((item) => {
        if (item.status === 'success') sucessVisitsCount++
        if (item.status === 'failure') failedVisitsCount++
      })
    }
  }
  return { sucessVisitsCount, failedVisitsCount }
}

export const billVisitUtil = async (visits, selectedDate) => {
  let failedVisits = []
  let result_visits = []

  let sucessVisitsCount = 0
  let failedVisitsCount = 0

  let rejectedBillsObj = []
  let otherBillsObj = []
  for (let i = 0; i < visits.length; i++) {
    const visit = visits[i]
    const visitId = visit.visitId || visit._id
    if (!visitId) {
      continue
    }

    if (visit?.status !== VISIT_STATUS.super_bill) {
      if (visit?.status === VISIT_STATUS.bill_rejected) {
        const body = {
          visit_id: visitId,
        }
        rejectedBillsObj.push(body)
      } else {
        const body = {
          visit_id: visitId,
        }
        otherBillsObj.push(body)
      }
    } else {
      visit.statuses_index.submit_bill = true
    }
  }

  if (rejectedBillsObj.length > 0) {
    const url = COLLECTOR_URL.BULK_BILL_STATUS_CHANGE
    let result = await bulkPostCollector(url, JSON.stringify(rejectedBillsObj))
    if (result?.status === 'success') {
      result.data.forEach((item) => {
        if (item.status === 'success') {
          sucessVisitsCount++
          result_visits.push(item)
        }
        if (item.status === 'failure') failedVisitsCount++
      })
    }
  }
  if (otherBillsObj.length > 0) {
    // if any have an 'unseen' status, update their status
    for (const visit of otherBillsObj) {
      try {
        const url = COLLECTOR_URL.VISIT_STATUS.replace('{visitId}', visit.visit_id)
        await putCollector(
          url,
          // the status we would prefer the visit to update to
          // if its in an 'unseen' state
          { status: VISIT_STATUS.checked_in },
        )
      } catch (error) {
        console.error('Error updating status data:', error)
      }
    }

    // bulk submit
    const url = COLLECTOR_URL.BULK_BILL_SUBMIT
    let result = await bulkPostCollector(url, {
      visit_id: otherBillsObj.map((x) => x.visit_id),
      service_date_from: selectedDate,
    })
    if (result?.status === 'sucesss') {
      result.data.forEach((item) => {
        if (item.status === 'success') {
          sucessVisitsCount++
          result_visits.push(item)
        }
        if (item.status === 'failure') {
          failedVisits.push(item)
          failedVisitsCount++
        }
      })
    }
    // catch unexpected backend error
    else if (result?.error && result?.message) {
      failedVisits.push({
        status: 'failure',
        err: {
          ...result.error,
          status: 'failure',
          result: result.message,
        },
      })
      failedVisitsCount++
    }
    // catch other unexpected backend error
    else if (result?.message) {
      failedVisits.push({
        status: 'failure',
        err: {
          status: 'failure',
          result: result.message,
        },
      })
      failedVisitsCount++
    }
  }
  return { sucessVisitsCount, failedVisitsCount, result_visits, failedVisits }
}
